import React, { useRef } from "react";
import { useSearchParams } from "react-router-dom";
import { clearLocalStorageOnLogout } from "../helpers/common";
import { isAllowedRedirectUrl, isAllowedReferrer } from "../helpers/crossLoginHelper";
import { withBase } from "@/helpers/basePath";

const CrossLogoutCallback = () => {
  const [searchParams] = useSearchParams();
  const hasProcessed = useRef(false);

  const returnUrl = searchParams.get("returnUrl");

  if (!hasProcessed.current) {
    hasProcessed.current = true;

    const referrer = document.referrer;
    if (!referrer || !isAllowedReferrer(referrer)) {
      window.location.href = withBase("/");
      return null;
    }

    clearLocalStorageOnLogout();

    const safeUrl = returnUrl && isAllowedRedirectUrl(returnUrl) ? returnUrl : withBase("/");
    window.location.href = safeUrl;
  }

  return null;
};

export default CrossLogoutCallback;
